import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoveMeasureVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={167}
    height={287}
    fill="none"
    {...props}
  >
    <path
      stroke="#EEEFFF"
      strokeWidth={3}
      d="M5.837 287c0-42.692-8.633-127.846 0-148.461 10.792-25.77 39.699-21.924 51.261-30 9.25-6.462 8.223-18.59 6.553-23.847-4.624-7.056-10.015-12.389-12.788-21.538-2.161-2.308-6.484-8.539-6.484-15s3.2-6.539 4.8-5.77C51.252 3.037 71.218 2 82.536 2c12.75 0 33.071 2.748 35.266 40.385 1.606-.513 4.819-.077 4.819 5.769s-4.323 12.436-6.484 15c-2.773 9.15-8.164 14.482-12.788 21.538-1.67 5.257-2.698 17.385 6.553 23.847 11.562 8.076 40.469 4.23 51.261 30 8.633 20.615 0 106.922 0 148.461"
    />
  </svg>
);
export default SvgMoveMeasureVector;
